import react, {useEffect, useMemo} from 'react';
import MyTable from '../components/myTable';
import {useSelector} from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Cookie from 'react-cookies';
import { FaPlus } from 'react-icons/fa';
import { getSlides, userList } from '../../api/api';

const Sliders = () => {
    // const marginLeft = useSelector(state => state.style.payload.marginLeft)
    const navigate = useNavigate();
    const data = useSelector(state => state.sliders.sliders);
   
    const fetchSlides = () => {
        const res = getSlides()

    }
    const columns = useMemo( () => [
        {
            Header: '#',
            accessor: (data, i) => {
                return (i+1)
            }
        },
        {
            Header: 'Photo',
            accessor: ((user) => (
                <img src={user.img} height={150} width={"100%"} />
            ))
        },
        {
            Header: 'Title',
            accessor: 'title',
        },
        {
            Header: 'Created_by',
            accessor: 'created_by'
        },
        {
            Header: 'Action',
            accessor: (data) => 
                (
                    <button className="form-control btn-sm btn-color"
                    style={{ 
                        fontSize: 12
                     }}
                    onClick={() => {
                        Cookie.save('editData', JSON.stringify(data));
                        navigate("/member_details")}}
                    >
                        Remove
                    </button>
                )
            
        }
    ], [])

    useEffect(() => {
        data.length == 0 && fetchSlides();
        // console.log(data)
        document.title = 'Sliders | Bida Sport Club'
    }, [])
    return data.length > 0 ? (
        <div className=''> 
            {/* <h2> Users </h2> */}
            <MyTable data ={data} columns={columns} pageName = {"Sliders List"}
             button = {<button className='btn btn-md btn-color'
             style={{ 
                 // width:'170px',
                 height: '40px'
              }}
             onClick={()=> navigate('/addSlide')}
             > <FaPlus /> Add New Slide </button>}
            />
        </div>
    ):
    (
        <div className=' row justify-content-center py-5'>
            <h4> <b className="mb-5 ms-5">Sliders List</b> </h4>
            <h3> <p className="mb-5 ms-5 text-center">Sliders List is Empty.</p> </h3>
        </div>
    )
}

export default Sliders